var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["pro-load", { "pro-load--loaded": _vm.loaded }] },
    [
      _vm.observer
        ? _c("Observer", { on: { intersectOn: _vm.loadImage } })
        : _vm._e(),
      _vm._v(" "),
      _c("img", {
        staticClass: "pro-load__img pro-load__img--small",
        attrs: { src: _vm.placeholder }
      }),
      _vm._v(" "),
      _c("img", {
        ref: "largeImage",
        staticClass: "pro-load__img pro-load__img--large",
        attrs: { src: "", alt: _vm.alt }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "pro-load__ratio",
        style: "padding-bottom: " + _vm.aspectRatio + "%"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }